import React from "react";
import AdsCarousel from "./AdsCarousel";
import { ADS_IMAGES } from "../data/adsConfig";

export default function PageWithSideBanners({ children }) {
  return (
    <div className="layoutShell">
      <aside className="sideBanner left">
        <AdsCarousel images={ADS_IMAGES} intervalMs={5000} lcp={true} />
      </aside>

      <main className="mainContent">{children}</main>

      <aside className="sideBanner right">
        <AdsCarousel images={ADS_IMAGES} intervalMs={5000} lcp={false} />
      </aside>
    </div>
  );
}
